import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';
import TrustPilotTwoLinesWidget from 'components/TrustPilotTwoLinesWidget';
import { TrustpilotCarouselWidget } from 'components/home-page/TrustpilotCarouselWidget';
import TrustpilotExcellent45Logo from 'components/TrustpilotExcellent45Logo';
import TrustpilotListWidget from 'components/TrustpilotListWidget';
import TrustpilotRatingWidget from 'components/TrustpilotRatingWidget';

const ComponentPreview = () => {
  return (
    <AboutUsModule background="grey">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">Trust Pilot Widgets</h3>
        <p>
          Various Trustpilot widgets that have been implemented depending on the
          design that was required
        </p>
        <h4 className="aboutUsTypographyHeaderMedium">
          TrustPilotTwoLinesWidget
        </h4>
        <p>
          Shows our score across two lines - stars at the top, then our custom
          text below. It is best shown centered in a container, as Trustpilot
          controls the positioning of elements within the widget
        </p>
        <div style={{ padding: 16, paddingLeft: 0, width: 250 }}>
          <TrustPilotTwoLinesWidget />
        </div>
        <h3 className="aboutUsTypographyHeaderLarge">
          Other Trust Pilot widgets
        </h3>
        <p>Various other Trustpilot widgets that exist in the code base</p>

        <h4 className="aboutUsTypographyHeaderMedium">
          TrustpilotCarouselWidget
        </h4>
        <TrustpilotCarouselWidget />

        <h4 className="aboutUsTypographyHeaderMedium">
          TrustpilotExcellent45Logo
        </h4>
        <TrustpilotExcellent45Logo />

        <h4 className="aboutUsTypographyHeaderMedium">TrustpilotListWidget</h4>
        <TrustpilotListWidget />

        <h4 className="aboutUsTypographyHeaderMedium">
          TrustpilotRatingWidget
        </h4>
        <TrustpilotRatingWidget style={undefined} />
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Trust Pilot Widgets',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
